import React from 'react';
import PropTypes from 'prop-types';
import humanFormat from 'human-format';
import { subscribe, disconnect } from '../../../channels/pub-sub-service';

export default function EngagementCount({ wire }) {
  const [count, setCount] = React.useState(wire.engagementCount);

  React.useEffect(() => () => disconnect(), []);

  React.useEffect(() => {
    subscribe(
      { channel: 'WireStatisticChannel', id: wire.id },
      {
        received: data => {
          const { engagementCount } = data;

          if (Number.isInteger(engagementCount)) {
            setCount(engagementCount);
          }
        },
      },
    );
  }, [wire.id]);

  return (
    <>
      <span className="icon-lw icon-lw-engagements" />
      <span className="count">{humanFormat(count, { decimals: 1 })}</span>
    </>
  );
}

EngagementCount.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
    engagementCount: PropTypes.number.isRequired,
  }).isRequired,
};
